import { propertyValue } from './dood-block-config';

/** Default cart column panel color (legacy hardcoded `bg-neutral-100`). */
export const CART_PAGE_PRESET_BLOCK_DEFAULT_BACKGROUND_COLOR = {
  type: 'palette',
  value: 'neutral-100',
} as const;

/**
 * Cart page preset blocks whose background is applied by `BlockFactoryComponent`
 * (blocks without their own configurable panel background in the webapp).
 */
export const CART_PAGE_PRESET_BLOCK_COMPONENT_TYPES_WITH_FACTORY_BACKGROUND = [
  'CartItemListBlockComponent',
  'CartMerchantAmountBlockComponent',
  'CartOnSiteLocationBlockComponent',
  'CartVoucherBlockComponent',
  'CartPrepaymentBlockComponent',
  'CartTipPickerBlockComponent',
  'CartAdditionalInformationBlockComponent',
  'ComoJoinLoyaltyBlockComponent',
  'ComoCreditBalanceCardBlockComponent',
] as const;

export type CartPagePresetBlockComponentTypeWithFactoryBackground =
  (typeof CART_PAGE_PRESET_BLOCK_COMPONENT_TYPES_WITH_FACTORY_BACKGROUND)[number];

export function isCartPagePresetBlockWithFactoryBackground(componentType: string): boolean {
  return (
    CART_PAGE_PRESET_BLOCK_COMPONENT_TYPES_WITH_FACTORY_BACKGROUND as readonly string[]
  ).includes(componentType);
}

export function cartPagePresetBlockBackgroundColorProperty(
  labelKey = 'pages.blocks.cart-page.background-color.label',
) {
  return propertyValue({
    type: 'color',
    value: CART_PAGE_PRESET_BLOCK_DEFAULT_BACKGROUND_COLOR,
    options: { label: labelKey },
  });
}
